import { AddBox } from '@mui/icons-material';
import { Grid } from '@mui/material';
import React, { useState, useEffect, useContext } from 'react';
import { Tabla, AvisoConfirmacion } from 'ui-component';
import MainCard from 'ui-component/cards/MainCard';
import Services from './Componnets/ServicesNotifications';
import LayautContext from 'Context/ContextLayaut';
import FormNotificacion from './Componnets/FormNotificacion';
import VistaNotificacion from './Componnets/Vistanotificacion ';

const NotificacionesInformativas = (props) => {
    const context = useContext(LayautContext);
    const [confirm, setConfirm] = useState({ open: false });
    const services = Services();
    const [data, setData] = useState([]);
    const [catalogos, setCatalogos] = useState({
        sedes: [],
        tiposUsuario: []
    });

    const actualizarData = (nuevaNotificacion) => {
        const dataActual = data.map((oc) => oc.idnotificacion);
        const nuevasNotificaciones = Array.isArray(nuevaNotificacion) ? nuevaNotificacion : [nuevaNotificacion];

        nuevasNotificaciones.forEach((notifI) => {
            const indice = dataActual.indexOf(notifI.idnotificacion);
            if (indice >= 0) data.splice(indice, 1, notifI);
            else data.splice(0, 0, notifI);
        });
        setData([...data]);
    };

    const abrirNuevaNotificacion = () => () => {
        context.formulario.abrir({
            open: true,
            titulo: 'Agregar notificación',
            propsForm: { catalogos: catalogos },
            width: 'md',
            formulario: FormNotificacion,
            aceptar: (formData) => {
                const dataFormPivote = { ...formData };
                const formDataToSend = new FormData();

                // Primero agregar todos los campos normales
                Object.keys(dataFormPivote).forEach((key) => {
                    if (key === 'imagen' && dataFormPivote[key]) {
                        formDataToSend.append('imagen', dataFormPivote[key]);
                    } else if (key !== 'imagen' && key !== 'dia_anual' && key !== 'mes_anual') {
                        formDataToSend.append(key, dataFormPivote[key]);
                    }
                });

                // Luego, si es ANUAL, sobrescribir fecha_inicio
                if (dataFormPivote.periodo === 'ANUAL' && dataFormPivote.dia_anual && dataFormPivote.mes_anual) {
                    const anioActual = new Date().getFullYear();
                    const mes = String(dataFormPivote.mes_anual).padStart(2, '0');
                    const dia = String(dataFormPivote.dia_anual).padStart(2, '0');
                    const fechaAnual = `${anioActual}-${mes}-${dia}`;

                    // Usar set para asegurar que sobrescribe
                    formDataToSend.set('fecha_inicio', fechaAnual);
                    formDataToSend.set('fecha_fin', '');
                }

                services.guardaNotificacion(
                    (res) => {
                        actualizarData(res);
                        context.formulario.cerrar();
                    },
                    formDataToSend,
                    {
                        headers: {
                            'content-type': 'multipart/form-data'
                        }
                    }
                );
            }
        });
    };

    const abrirConfirmarCambioEstatus = (notificacion) => (e) => {
        let texto = `¿Estás seguro de volver a activar la notificación "${notificacion.Titulo}"?`;
        let status = 1;
        if (notificacion.estatus == 1 || notificacion.estatus === '1') {
            texto = `¿Estás seguro de desactivar la notificación "${notificacion.Titulo}"?`;
            status = 0;
        }
        setConfirm({
            open: true,
            text: texto,
            aceptar: () =>
                services.cambiarEstatusNotificacion(
                    (nuevaData) => {
                        actualizarData(nuevaData);
                        setConfirm({ open: false });
                    },
                    { idnotificacion: notificacion.idnotificacion, estatus: status }
                )
        });
    };

    const acciones = [{ label: 'Nueva notificación', icon: <AddBox />, click: abrirNuevaNotificacion, disabled: false }];

    const columns = [
        { label: 'Título', name: 'Titulo', filtrar: true },
        { label: 'Fecha inicio', name: 'fecha_inicio_tabla', filtrar: true },
        { label: 'Fecha fin', name: 'fecha_fin_tabla', filtrar: true },
        { label: 'Periodo', name: 'periodo_nombre', filtrar: true },
        { label: 'Tipo usuario', name: 'TipoUsuario_nombre', filtrar: true },
        { label: 'Sede', name: 'sede_nombre', filtrar: true },
        {
            label: 'Estatus',
            name: 'estatus',
            filtrar: false,
            type: { opcion: 'switch', accion: abrirConfirmarCambioEstatus }
        }
    ];

    const verNotificacion = (item) => {
        context.formulario.abrir({
            open: true,
            titulo: 'Detalle de la notificación',
            propsForm: { item: item },
            formulario: VistaNotificacion,
            isVer: true,
            aceptar: () => {}
        });
    };

    const editarNotificacion = (item) => {
        context.formulario.abrir({
            open: true,
            titulo: 'Editar notificación',
            propsForm: { catalogos: catalogos, defaultItem: item },
            width: 'md',
            formulario: FormNotificacion,
            aceptar: (formData) => {
                const dataFormPivote = { ...formData };
                const formDataToSend = new FormData();

                formDataToSend.append('idnotificacion', item.idnotificacion);

                // Primero agregar todos los campos
                Object.keys(dataFormPivote).forEach((key) => {
                    if (key === 'imagen' && dataFormPivote[key]) {
                        formDataToSend.append('imagen', dataFormPivote[key]);
                    } else if (key !== 'imagen' && key !== 'dia_anual' && key !== 'mes_anual') {
                        formDataToSend.append(key, dataFormPivote[key]);
                    }
                });

                // Si es ANUAL, sobrescribir fecha_inicio
                if (dataFormPivote.periodo === 'ANUAL' && dataFormPivote.dia_anual && dataFormPivote.mes_anual) {
                    const anioActual = new Date().getFullYear();
                    const mes = String(dataFormPivote.mes_anual).padStart(2, '0');
                    const dia = String(dataFormPivote.dia_anual).padStart(2, '0');
                    const fechaAnual = `${anioActual}-${mes}-${dia}`;

                    formDataToSend.set('fecha_inicio', fechaAnual);
                    formDataToSend.set('fecha_fin', '');
                }

                services.editaNotificacion(
                    (res) => {
                        actualizarData(res);
                        context.formulario.cerrar();
                    },
                    formDataToSend,
                    {
                        headers: {
                            'content-type': 'multipart/form-data'
                        }
                    }
                );
            }
        });
    };

    const eliminaNotificacion = (item) => {
        setConfirm({
            open: true,
            text: `La notificación "${item.Titulo}" será eliminada. ¿Desea continuar?`,
            aceptar: () =>
                services.eliminaNotificacion(
                    (nuevaData) => {
                        let arrActual = data;
                        if (nuevaData == true) {
                            let index = arrActual.findIndex((x) => x.idnotificacion == item.idnotificacion);
                            if (index != -1) {
                                arrActual.splice(index, 1);
                                setData([...arrActual]);
                                setConfirm({ open: false });
                            }
                        }
                    },
                    { idnotificacion: item.idnotificacion }
                )
        });
    };

    const accionesFila = [
        { label: 'Ver', onClick: verNotificacion, enabled: (row) => true },
        { label: 'Editar', onClick: editarNotificacion, enabled: (row) => true }
    ];

    useEffect(() => {
        services.getNotificaciones((res) => {
            setData(res.data);
            setCatalogos({
                sedes: res.sedes,
                tiposUsuario: res.tiposUsuario
            });
        });
    }, []);

    return (
        <MainCard title="Notificaciones Informativas">
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Tabla rows={data} columns={columns} accionesFila={accionesFila} accionesTabla={acciones} columnKey="idnotificacion" />
                </Grid>
            </Grid>

            <AvisoConfirmacion
                open={confirm.open}
                title="Advertencia"
                text={confirm.text}
                accept={confirm.aceptar}
                cancel={() => setConfirm({ open: false })}
            />
        </MainCard>
    );
};

export default NotificacionesInformativas;
